import ChevronDownIcon from "../_icons/chevronDownIcon";
import { Dispatch, SetStateAction, useEffect } from "react";
import { Merchant } from "@/dto/merchant";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { useCategoryInView } from "@/utils/useCategoryInView";
import { DayPart } from "@/dto/dayPartMenu";
import { isEmpty } from "lodash";

export interface CategoryButtonProps {
  setIsCategoryMenuOpen: Dispatch<SetStateAction<boolean>>;
  merchant: Merchant;
  selectedDayPart?: DayPart | null;
}

export const CategoryButton = ({
  setIsCategoryMenuOpen,
  merchant,
  selectedDayPart = null,
}: CategoryButtonProps) => {
  const path = usePathname();
  const t = useTranslations("CategoryButton");
  const isHybridServiceMerchant =
    merchant?.isHybrid && path?.includes("services");
  const isHybridShopMerchant =
    (merchant?.isHybrid ||
      (merchant.isService && merchant.hasOnlyRetailItems)) &&
    path?.includes("shop");
  const handleCategoryClick = () => {
    setIsCategoryMenuOpen(true);
  };

  const getDefaultText = () => {
    if (merchant?.isEssentialMerchant || isHybridShopMerchant) {
      return t("categories");
    }
    if (merchant?.isService || isHybridServiceMerchant) {
      return t("services");
    }

    return t("menu");
  };

  const [categoryText, setCategoryText] = useCategoryInView();
  const displayedText = categoryText ? categoryText : getDefaultText();

  useEffect(() => {
    if (isEmpty(selectedDayPart)) return;
    setCategoryText(getDefaultText());
  }, [selectedDayPart]);

  return (
    <div
      className="w-full mr-4 sm:hidden rounded-lg border border-[#D5D5D5] justify-between flex items-center px-4 py-1"
      onClick={handleCategoryClick}
    >
      <span className="text-sm font-medium leading-[21px] py-1 line-clamp-1">
        {displayedText}
      </span>
      <ChevronDownIcon className="pl-4" />
    </div>
  );
};
